import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainRootComponent } from './components/main-root/main-root.component';
import { CustomizerTabBarComponent } from './components/customizer-tab-bar/customizer-tab-bar.component';
import { PreviewerComponent } from './components/previewer/previewer.component';
import { MatButtonModule } from '@angular/material/button';
import { MatTreeModule } from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { SummaryComponent } from './components/summary/summary.component';
import { MainImageComponent } from './components/main-image/main-image.component';
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PriceComponent } from './components/price/price.component';
import { MatCardModule } from '@angular/material/card';
import { AttributeMenuComponent } from './components/attribute-menu/attribute-menu.component';
import { TestContentDirective } from './directives/test-content.directive';
import { DesignComponent } from './components/design/design.component';
import { FormComponent } from './components/form/form.component';
import { MaterialComponent } from './components/material/material.component';
import { WidthComponent } from './components/width/width.component';
import { FeaturesComponent } from './components/features/features.component';
import { SizeComponent } from './components/size/size.component';
import { EngravingComponent } from './components/engraving/engraving.component';
import { DesignSearchComponent } from './components/design-search/design-search.component';
import { DesignCardComponent } from './components/design-card/design-card.component';
import { SelectionIndicatorComponent } from './components/selection-indicator/selection-indicator.component';
import { KaratSelectComponent } from './components/karat-select/karat-select.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { AttributeFilterComponent } from './components/attribute-filter/attribute-filter.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FakeContentDirective } from './directives/fake-content.directive';
import { MaterialSelectComponent } from './components/material-select/material-select.component';
import { MatDialogModule } from '@angular/material/dialog';
import { LoadingIndicatorModule } from 'src/app/modules/loading-indicator/loading-indicator.module';
import { MatSelectModule } from '@angular/material/select';
import { CustomizerPanel2Component } from './components/customizer-panel2/customizer-panel2.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { ResetDialogComponent } from './components/reset.dialog/reset.dialog.component';
import { SkuDialogComponent } from './components/sku.dialog/sku.dialog.component';
import { InvalidSkuDialogComponent } from './components/invalid-sku.dialog/invalid-sku.dialog.component';
import { CheckoutDialogComponent } from './components/checkout.dialog/checkout.dialog.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { CheckoutSummaryComponent } from './components/checkout-summary/checkout-summary.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { UnavailableDialogComponent } from './components/unavailable.dialog/unavailable.dialog.component';
import { CustomerDetailsErrorDialogComponent } from './components/customer-details-error.dialog/customer-details-error.dialog.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { NonClosableErrorDialogComponent } from './components/non-closable-error.dialog/non-closable-error.dialog.component';
import { AdminControlsComponent } from './components/admin-controls/admin-controls.component';
import { AdminControlsSingleTextureViewerComponent } from './components/admin-controls-single-texture-viewer/admin-controls-single-texture-viewer.component';
import { AdminControlsTextureCheckComponent } from './components/admin-controls-texture-check/admin-controls-texture-check.component';
import { RetailerSummaryComponent } from './components/retailer-summary/retailer-summary.component';
import { BookmarksComponent } from './components/bookmarks/bookmarks.component';
import { DenyVisibilityDialogComponent } from './components/deny-visibility.dialog/deny-visibility.dialog.component';
import { ConfirmBookmarkDeleteDialogComponent } from './components/confirm-bookmark-delete.dialog/confirm-bookmark-delete.dialog.component';
import { ConfirmClearBookmarksDialogComponent } from './components/confirm-clear-bookmarks.dialog/confirm-clear-bookmarks.dialog.component';
import { StyleImageThumbnailsComponent } from './components/style-image-thumbnails/style-image-thumbnails/style-image-thumbnails.component';
import { StyleImageGalleryComponent } from './components/style-image-gallery/style-image-gallery.component';
import { GemstonesComponent } from './components/gemstones/gemstones/gemstones.component';
import { GemstoneCardComponent } from './components/gemstone-card/gemstone-card/gemstone-card.component';
import { TopBarComponent } from "./components/top-bar/top-bar/top-bar.component";
import { BottomBarComponent } from './components/bottom-bar/bottom-bar/bottom-bar.component';
import { A11yModule } from "@angular/cdk/a11y";
import { ItemSearchComponent } from './components/item-search/item-search/item-search.component';
import { ShareSectionComponent } from './components/share-section/share-section/share-section.component';
import { DesignExplorerComponent } from './components/design-explorer/design-explorer/design-explorer.component';

@NgModule({
  declarations: [
    MainRootComponent,
    CustomizerTabBarComponent,
    PreviewerComponent,
    SummaryComponent,
    MainImageComponent,
    PriceComponent,
    AttributeMenuComponent,
    TestContentDirective,
    DesignComponent,
    FormComponent,
    MaterialComponent,
    WidthComponent,
    FeaturesComponent,
    SizeComponent,
    EngravingComponent,
    DesignSearchComponent,
    DesignCardComponent,
    SelectionIndicatorComponent,
    KaratSelectComponent,
    ToolbarComponent,
    AttributeFilterComponent,
    FakeContentDirective,
    MaterialSelectComponent,
    CustomizerPanel2Component,
    ProgressBarComponent,
    ResetDialogComponent,
    SkuDialogComponent,
    InvalidSkuDialogComponent,
    CheckoutDialogComponent,
    CheckoutSummaryComponent,
    UnavailableDialogComponent,
    CustomerDetailsErrorDialogComponent,
    NonClosableErrorDialogComponent,
    AdminControlsComponent,
    AdminControlsSingleTextureViewerComponent,
    AdminControlsTextureCheckComponent,
    RetailerSummaryComponent,
    BookmarksComponent,
    DenyVisibilityDialogComponent,
    ConfirmBookmarkDeleteDialogComponent,
    ConfirmClearBookmarksDialogComponent,
    StyleImageThumbnailsComponent,
    StyleImageGalleryComponent,
    GemstonesComponent,
    GemstoneCardComponent,
    TopBarComponent,
    BottomBarComponent,
    ItemSearchComponent,
    ShareSectionComponent,
    DesignExplorerComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatTreeModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatSlideToggleModule,
    MatDialogModule,
    LoadingIndicatorModule,
    MatSelectModule,
    MatCheckboxModule,
    MatSnackBarModule,
    ClipboardModule,
    MatSnackBarModule,
    A11yModule
],
  exports: [
    MainRootComponent,
    CustomizerTabBarComponent,
    PreviewerComponent,
    SummaryComponent,
    MainImageComponent,
    PriceComponent,
    AttributeMenuComponent,
    TestContentDirective,
    DesignComponent,
    FormComponent,
    MaterialComponent,
    WidthComponent,
    FeaturesComponent,
    SizeComponent,
    EngravingComponent,
    DesignSearchComponent,
    DesignCardComponent,
    SelectionIndicatorComponent,
    KaratSelectComponent,
    ToolbarComponent,
    AttributeFilterComponent,
    FakeContentDirective,
    MaterialSelectComponent,
    CustomizerPanel2Component,
    ProgressBarComponent,
    ResetDialogComponent,
    SkuDialogComponent,
    InvalidSkuDialogComponent,
    CheckoutDialogComponent,
    CheckoutSummaryComponent,
    UnavailableDialogComponent,
    CustomerDetailsErrorDialogComponent,
    NonClosableErrorDialogComponent,
    AdminControlsComponent,
    AdminControlsSingleTextureViewerComponent,
    AdminControlsTextureCheckComponent,
    RetailerSummaryComponent,
    BookmarksComponent,
    DenyVisibilityDialogComponent,
    ConfirmBookmarkDeleteDialogComponent,
    ConfirmClearBookmarksDialogComponent,
    StyleImageThumbnailsComponent,
    StyleImageGalleryComponent,
    GemstonesComponent,
    GemstoneCardComponent,
    ItemSearchComponent,
    ShareSectionComponent,
    DesignExplorerComponent
  ]
})
export class MainPageModule { }
